<template>
<div style="background: linear-gradient(#23242b, #08080a) !important;">
    <header>
    <a @click="()=>$router.go(-1)" class="btn-back">
        <img src="@/assets/img/i-left-white.png" alt="">
    </a>
</header>
<div class="mt">
    <p class="tit">
        自助借还书系统
    </p>
    <p class="s-tit">
        上业科技
    </p>
</div>
<div class="mc">
    <div class="warning-box">
        <p :class="{'warning':true,'hidden':!error}">
            {{warningText}}
        </p>
    </div>
    <div class="l-row">
        <input type="text" v-model="username" placeholder="输入读者账号" class="mipt">
        <button type="button"   class="mclear" ></button>
    </div>
    <div class="l-row">
        <input type="password" v-model="password" placeholder="密码" class="mipt">
        <button type="button"   class="mclear"></button>
    </div>
    <div class="l-row btn-row">
        <!--<input type="button" class="btn-sure" disabled value="登录">-->
        <a @click="handleLogin"  class="btn-sure btn-sure-d disabled" role="button">登录</a>
        <!--未输入时.disabled-->
    </div>
</div>
<div class="mb">
    <a href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx059abae146bf4044&redirect_uri=https://book-wechat.sybaike.net/cloud/wechat&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect" class="login-wechat">
        <img src="@/assets/img/bt_menu_wechat_normal.png" alt="">
        <p>微信授权登录</p>
    </a>
</div>
</div>
</template>
<script>
import { login } from "@/api/user";
import { USER,CUSTOMER } from "@/store/mutation-types";
export default {
  data() {
    return {
      username: "",
      password: "",
      error: false,
      warningText: "帐号/密码错误，请确认后输入",
      customerId:""
    };
  },
  methods: {
    handleLogin() {
       this.customerId =  this.$route.query.customerId || this.$ls.get("CUSTOMER") 
      if(this.customerId ==null ||this.customerId==""){
         this.error = true;
        this.warningText = "缺少客户信息，联系管理员";
        return;
      }
      if (this.username.length == 0 || this.password.length == 0) {
        this.error = true;
        this.warningText = "账户/密码不能为空";
      } else {
        login({ username: this.username, password: this.password,"customerId":this.customerId })
          .then((res) => {
            console.log("res", res);
            this.$ls.set(USER, res.data);
            this.$ls.set(CUSTOMER, this.customerId);
            if (window.history.length <= 1) {
              this.$router.push({  name: "Devices" });
            } else {
              this.$router.go(-1);
            }
          })
          .catch((error) => {
            console.log("error", error);
            this.error = true;
            this.warningText = error.response.data.message;
          });
      }
    },
  },
  mounted() {
    var deviceWidth;
    setHtmlFontSize();

    if (window.addEventListener) {
      window.addEventListener(
        "resize",
        function() {
          setHtmlFontSize();
        },
        false
      );
    }
    function setHtmlFontSize() {
      // 1920设计稿宽度
      deviceWidth =
        document.documentElement.clientWidth > 750
          ? 750
          : document.documentElement.clientWidth;
      document.getElementsByTagName("html")[0].style.cssText =
        "font-size:" + deviceWidth / 7.5 + "px !important";
    }
     this.customerId =  this.$route.query.customerId || this.$ls.get("CUSTOMER") 
      if(this.customerId ==null ||this.customerId==""){
         this.error = true;
        this.warningText = "缺少客户信息，联系管理员";
      }else{
          this.$ls.set(CUSTOMER, this.customerId);
      }
  },
};
</script>
<style scoped>
body {
  min-height: 100%;
  font-family: "Microsoft YaHei";
  background: linear-gradient(#23242b, #101013) !important;
}
header {
  height: auto;
  padding: 0.35rem 0.3rem 0;
}
header a.btn-back {
  display: inline-block;
  height: 0.28rem;
}
header a.btn-back img {
  height: 100%;
  vertical-align: middle;
}
.mt {
  padding-top: 0.75rem;
  text-align: center;
  letter-spacing: 0.08rem;
  color: #fff;
}
.mt .tit {
  font-size: 0.46rem;
  margin-bottom: 0.12rem;
  font-family: RZZY;
}
.mt .s-tit {
  font-size: 0.28rem;
  font-weight: 700;
}
.mc {
  margin-top: 0.79rem;
  padding: 0 0.3rem;
}
.mc .warning-box {
  margin-bottom: 0.27rem;
  padding-left: 0.29rem;
  height: 0.26rem;
}
.mc .warning-box .warning {
  color: #ff3b3b;
  font-size: 0.24rem;
}
.mc .l-row {
  margin-bottom: 0.2rem;
  position: relative;
}
.mc .l-row input {
  width: 100%;
  height: 0.78rem;
  padding: 0 0.8rem 0 0.3rem;
  border: 0.02rem solid #cccccc;
  background: #fff;
  border-radius: 0.08rem;
  outline: none;
  font-size: 0.26rem;
  line-height: 0.78rem;
  color: #000;
}
.mc .l-row ::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #858585;
}
.mc .l-row ::-moz-placeholder {
  /* Firefox 19+ */
  color: #858585;
}
.mc .l-row :-ms-input-placeholder {
  /* IE 10+ */
  color: #858585;
}
.mc .l-row :-moz-placeholder {
  /* Firefox 18- */
  color: #858585;
}
.mc .l-row .mclear {
  display: none;
  outline: none;
  border: 0;
  /*去掉button按钮的棱角(边框)   */
  position: absolute;
  /*子元素的绝对定位    */
  top: 50%;
  margin-top: -0.135rem;
  height: 0.27rem;
  width: 0.26rem;
  right: 0.3rem;
  /* 按钮的绝对定位的位置   */
  background: url("/assets/img/i-clean.png") no-repeat;
  /* 按钮的背景图片  */
  background-size: 0.26rem 0.27rem;
  /* 背景图片的大小  */
}
.mc .l-row.btn-row {
  margin-top: 0.46rem;
  margin-bottom: 0;
}
.mc .l-row.btn-row .btn-sure {
  display: inline-block;
  width: 100%;
  height: 0.78rem;
  padding: 0;
  border: none;
  background: #d78209;
  border-radius: 0.08rem;
  outline: none;
  font-size: 0.26rem;
  line-height: 0.78rem;
  color: #fff;
  text-align: center;
}
.mb {
  margin-top: 0.48rem;
  text-align: center;
}
.mb .login-wechat {
  display: inline-block;
}
.mb .login-wechat img {
  height: 0.84rem;
  vertical-align: middle;
}
.mb .login-wechat p {
  margin-top: 0.35rem;
  font-size: 0.24rem;
  color: #8f8f8f;
}
</style>
